import "./methodologies.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import MethodologiesCards from "@frontend/js/Components/Shared/MethodologiesCards/MethodologiesCards";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import useT from "@frontend/js/hooks/useT";
import { usePage } from "@inertiajs/react";


export default function Methodologies({
    page,
    collection,
    meta = {
        title: "",
        description: "",
    },
}) {
    const { t } = useT("site");
    const pageProps = usePage().props;
    const locale = pageProps.currentLocale;
    const cards = collection?.data || [];
    const content = page?.content?.[locale] || "";
    const pageTitle = page?.title?.[locale] || meta?.title || "";

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="methodologies page-shell">
                    <PageTitleBreadcrumb title={pageTitle} />
                    <div className="methodologies__cards">

                    <MethodologiesCards cards={cards} />
                    </div>
                    <div className="methodologies__text">
                        <h2>{t("methodologies-description-title")}</h2>
                        <div className="methodologies__text__info">
                            <div
                                dangerouslySetInnerHTML={{ __html: content }}
                            />
                        </div>
                    </div>
                </div>
            </SiteLayout>
        </>
    );
}

